<template>
    <div class="text-center">{{ this.$slots.default[0].text }}</div>
</template>
<script>
export default {
    name: 'EmbedTextCenter'
}
</script>
